import api from "../../../api";
import {typedQuery} from "../../typing";

export const thirdPartyTiers = typedQuery(["tprm", "thirdPartyTiers"], async () => {
  return await api.tprm.thirdPartyTiers.list();
});
